import { Observable, from } from "rxjs";

import { services, validateFunctionResult } from "@progressive-development/pd-spa-helper";
import { bookmark } from "@progressive-development/politik-model";

import { handleGetFunc, handlePutFunc } from "../../../../config/service-configuration.js";

/**
 * Bookmarks Service (Merkliste) — der volle CRUD-Satz.
 *
 * Pattern: Service kapselt den API-Vertrag (object, type). Methoden nehmen nur
 * Business-Daten, der Service baut das Call-Objekt intern. list/detail laufen
 * über den Read-Dispatcher, add/update/delete über den Write-Dispatcher.
 */
export class BookmarksService {
  public listBookmarks(): Observable<bookmark.Bookmark[]> {
    const call: bookmark.BookmarkListCall = {
      object: bookmark.BOOKMARK_OBJECT,
      type: "list",
    };
    return from(
      services.functions
        .callFunction(handleGetFunc.name, call)
        .then((result) => validateFunctionResult<bookmark.Bookmark[]>(result, handleGetFunc)),
    );
  }

  public addBookmark(details: bookmark.AddBookmark): Observable<bookmark.Bookmark> {
    const call: bookmark.BookmarkAddCall = {
      object: bookmark.BOOKMARK_OBJECT,
      type: "add",
      details,
    };
    return from(
      services.functions
        .callFunction(handlePutFunc.name, call)
        .then((result) => validateFunctionResult<bookmark.Bookmark>(result, handlePutFunc)),
    );
  }

  public updateBookmark(id: string, patch: bookmark.UpdateBookmark): Observable<bookmark.Bookmark> {
    const call: bookmark.BookmarkUpdateCall = {
      object: bookmark.BOOKMARK_OBJECT,
      type: "update",
      detailsId: id,
      details: patch,
    };
    return from(
      services.functions
        .callFunction(handlePutFunc.name, call)
        .then((result) => validateFunctionResult<bookmark.Bookmark>(result, handlePutFunc)),
    );
  }

  public deleteBookmark(id: string): Observable<bookmark.DeletedBookmark> {
    const call: bookmark.BookmarkDeleteCall = {
      object: bookmark.BOOKMARK_OBJECT,
      type: "delete",
      detailsId: id,
    };
    return from(
      services.functions
        .callFunction(handlePutFunc.name, call)
        .then((result) => validateFunctionResult<bookmark.DeletedBookmark>(result, handlePutFunc)),
    );
  }
}

export const bookmarksService = new BookmarksService();
